// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2V11.5C4 12.88 5.12 14 6.5 14H9.5C10.88 14 12 12.88 12 11.5V2',
  'M3 2H13',
  'M4 9.6C6.4 8.4 9.6 10.8 12 9.6',
];
